import { FC, Ref } from 'react';

import { StockLevelStatuses } from '@telialt/models/src/EshopModel';

import { CartSummaryTotalPriceBlock } from '../CartSummaryBox/CartSummaryTotalPriceBlock';
import { PreOrderBanner } from '../CartSummaryBox/PreOrderBanner';
import { useProductStock } from '../hooks/useProductStock';
import { ESHOP_TEST_ID } from '../test/test-ids';
import {
    StickySummaryContainer,
    StickySummaryPriceBlock,
    StickySummaryProductName,
    StickySummarySection,
    StickySummaryWrapper,
} from './StickySummary.styles';

type Props = {
    isVisible: boolean;
    ref?: Ref<HTMLElement>;
    baseProductName?: string;
};

export const StickySummary: FC<Props> = ({ isVisible, ref, baseProductName }) => {
    const { stock } = useProductStock();
    const isPreOrder = stock?.stockLevelStatus === StockLevelStatuses.FutureStock;

    return (
        <StickySummaryWrapper
            data-test={ESHOP_TEST_ID.DESKTOP_STICKY_SUMMARY}
            $isVisible={isVisible}
            ref={ref as Ref<HTMLDivElement>}
        >
            {isPreOrder && <PreOrderBanner isSticky={true} />}

            <StickySummarySection>
                <StickySummaryContainer>
                    <StickySummaryProductName data-test={ESHOP_TEST_ID.STICKY_SUMMARY_PRODUCT_NAME}>
                        {baseProductName}
                    </StickySummaryProductName>
                    <StickySummaryPriceBlock>
                        <CartSummaryTotalPriceBlock isStickySummary={true} />
                    </StickySummaryPriceBlock>
                </StickySummaryContainer>
            </StickySummarySection>
        </StickySummaryWrapper>
    );
};
